export const LOGIN_E2E_SELECTORS = {
    emailInput: 'login-email-input',
    passwordInput: 'login-password-input',
    submitButton: 'login-submit-button',
    forgotPasswordButton: 'login-forgot-password-button',
    microsoftButton: 'login-microsoft-button',
    errorMessage: 'login-error-message',
} as const;
